export default {
  'app.settings.title': 'Танзимот',
  'app.settings.language': 'Забон',
};


